module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-01-5f4149218c8967b809f3e80c1c89e8c0.webp";